import { jwtDecode } from 'jwt-decode';

interface AuthProps {
  apiToken: string;
}

export const IsUserLoggedIn = ({
  apiToken = localStorage.getItem('x-tifin-ai-auth') as string,
}: AuthProps): boolean => {
  if (
    apiToken !== undefined &&
    typeof apiToken === 'string' &&
    apiToken.trim().length > 0
  ) {
    const decoded = jwtDecode(apiToken) || {};
    if (decoded?.exp && decoded.exp > Math.floor(Date.now() / 1000)) {
      return true;
    }
  }
  return false;
};
